import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { LDContext } from 'launchdarkly-js-client-sdk';


import {
  PARTNERS,
} from 'config/app-config';
import { getSessionStoragePartner } from 'utils/getSessionStoragePartner';
import { checkMatchPath } from 'utils/misc';

export const useLaunchDarklyContext = () => {
  const ldClient = useLDClient();

  useEffect(() => {
    const partnerPath = getSessionStoragePartner();
    const currentContext = ldClient?.getContext();
    const journey = Object.entries(PARTNERS).find(([, value]) => {
      return checkMatchPath(value, partnerPath);
    })?.[0];

    if (!ldClient || !journey) {
      return;
    }

    try {
      const newContext: LDContext = {
        ...(currentContext || {}),
        journey: {
          key: journey
        }
      };


      ldClient?.identify(newContext);
    } catch (e) {
      // istanbul ignore next -- @preserve
      console.error(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};